export default {
  "gemGoodsTypeAdmin.thead.index": "#NO",
  "gemGoodsTypeAdmin.thead.sort": "排序",
  "gemGoodsTypeAdmin.thead.typeName": "类型名称",
  "gemGoodsTypeAdmin.thead.typeId": "类型Id",
  "gemGoodsTypeAdmin.thead.unit": "单位(unit)",
  "gemGoodsTypeAdmin.thead.isRealGoods": "是否实物",
  "gemGoodsTypeAdmin.thead.createdAt": "创建时间",
  "gemGoodsTypeAdmin.thead.updatedAt": "更新新时间",

  "gemGoodsTypeAdmin.add": "新增",
  "gemGoodsTypeAdmin.edit": "编辑",
  "gemGoodsTypeAdmin.details": "详情",
  "gemGoodsTypeAdmin.delete": "删除",
  "gemGoodsTypeAdmin.thead.action": "操作",
};
